export default {
    "AF": {
        "name": "Afganistan"
    },
    "AL": {
        "name": "Albania"
    },
    "DZ": {
        "name": "Algeria"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua și Barbuda"
    },
    "AR": {
        "name": "Argentina"
    },
    "AM": {
        "name": "Armenia"
    },
    "AU": {
        "name": "Australia"
    },
    "AT": {
        "name": "Austria"
    },
    "AZ": {
        "name": "Azerbaidjan"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BH": {
        "name": "Bahrain"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BB": {
        "name": "Barbados"
    },
    "BY": {
        "name": "Belarus"
    },
    "BE": {
        "name": "Belgia"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BO": {
        "name": "Bolivia"
    },
    "BA": {
        "name": "Bosnia și Herțegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brazilia"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgaria"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "KH": {
        "name": "Cambodgia"
    },
    "CM": {
        "name": "Camerun"
    },
    "CA": {
        "name": "Canada"
    },
    "CV": {
        "name": "Republica Capului Verde"
    },
    "CF": {
        "name": "Republica Centrafricană"
    },
    "TD": {
        "name": "Ciad"
    },
    "CL": {
        "name": "Chile"
    },
    "CN": {
        "name": "Republica Populară Chineză"
    },
    "CO": {
        "name": "Columbia"
    },
    "KM": {
        "name": "Comore"
    },
    "CG": {
        "name": "Congo"
    },
    "CD": {
        "name": "Republica Democrată Congo"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "CI": {
        "name": "Coasta de Fildeș"
    },
    "HR": {
        "name": "Croația"
    },
    "CU": {
        "name": "Cuba"
    },
    "CY": {
        "name": "Cipru"
    },
    "CZ": {
        "name": "Cehia"
    },
    "DK": {
        "name": "Danemarca"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "Republica Dominicană"
    },
    "EC": {
        "name": "Ecuador"
    },
    "EG": {
        "name": "Egipt"
    },
    "SV": {
        "name": "El Salvador"
    },
    "GQ": {
        "name": "Guineea Ecuatorială"
    },
    "ER": {
        "name": "Eritreea"
    },
    "EE": {
        "name": "Estonia"
    },
    "ET": {
        "name": "Etiopia"
    },
    "FJ": {
        "name": "Fiji"
    },
    "FI": {
        "name": "Finlanda"
    },
    "FR": {
        "name": "Franța"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GE": {
        "name": "Georgia"
    },
    "DE": {
        "name": "Germania"
    },
    "GH": {
        "name": "Ghana"
    },
    "GR": {
        "name": "Grecia"
    },
    "GD": {
        "name": "Grenada"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guineea"
    },
    "GW": {
        "name": "Guineea-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haiti"
    },
    "HN": {
        "name": "Honduras"
    },
    "HU": {
        "name": "Ungaria"
    },
    "IS": {
        "name": "Islanda"
    },
    "IN": {
        "name": "India"
    },
    "ID": {
        "name": "Indonezia"
    },
    "IR": {
        "name": "Iran"
    },
    "IQ": {
        "name": "Irak"
    },
    "IE": {
        "name": "Republica Irlanda"
    },
    "IL": {
        "name": "Israel"
    },
    "IT": {
        "name": "Italia"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japonia"
    },
    "JO": {
        "name": "Iordania"
    },
    "KZ": {
        "name": "Kazahstan"
    },
    "KE": {
        "name": "Kenya"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KP": {
        "name": "Coreea de Nord"
    },
    "KR": {
        "name": "Coreea de Sud"
    },
    "KW": {
        "name": "Kuweit"
    },
    "KG": {
        "name": "Kârgâzstan"
    },
    "LA": {
        "name": "Laos"
    },
    "LV": {
        "name": "Letonia"
    },
    "LB": {
        "name": "Liban"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Lituania"
    },
    "LU": {
        "name": "Luxemburg"
    },
    "MK": {
        "name": "Republica Macedonia"
    },
    "MG": {
        "name": "Madagascar"
    },
    "MW": {
        "name": "Malawi"
    },
    "MY": {
        "name": "Malaezia"
    },
    "MV": {
        "name": "Maldive"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MH": {
        "name": "Insulele Marshall"
    },
    "MR": {
        "name": "Mauritania"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Mexic"
    },
    "FM": {
        "name": "Micronezia"
    },
    "MD": {
        "name": "Republica Moldova"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongolia"
    },
    "ME": {
        "name": "Muntenegru"
    },
    "MA": {
        "name": "Maroc"
    },
    "MZ": {
        "name": "Mozambic"
    },
    "MM": {
        "name": "Myanmar"
    },
    "NA": {
        "name": "Namibia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Nepal"
    },
    "NL": {
        "name": "Țările de Jos"
    },
    "NZ": {
        "name": "Noua Zeelandă"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "NO": {
        "name": "Norvegia"
    },
    "OM": {
        "name": "Oman"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papua Noua Guinee"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Peru"
    },
    "PH": {
        "name": "Filipine"
    },
    "PL": {
        "name": "Polonia"
    },
    "PT": {
        "name": "Portugalia"
    },
    "QA": {
        "name": "Qatar"
    },
    "RO": {
        "name": "România"
    },
    "RU": {
        "name": "Rusia"
    },
    "RW": {
        "name": "Rwanda"
    },
    "KN": {
        "name": "Sfântul Kitts și Nevis"
    },
    "LC": {
        "name": "Sfânta Lucia"
    },
    "VC": {
        "name": "Sfântul Vincent și Grenadine"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Marino"
    },
    "ST": {
        "name": "Sao Tome și Principe"
    },
    "SA": {
        "name": "Arabia Saudită"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Serbia"
    },
    "SC": {
        "name": "Seychelles"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapore"
    },
    "SK": {
        "name": "Slovacia"
    },
    "SI": {
        "name": "Slovenia"
    },
    "SB": {
        "name": "Insulele Solomon"
    },
    "SO": {
        "name": "Somalia"
    },
    "ZA": {
        "name": "Africa de Sud"
    },
    "ES": {
        "name": "Spania"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "SD": {
        "name": "Sudan"
    },
    "SS": {
        "name": "Sudanul de Sud"
    },
    "SR": {
        "name": "Surinam"
    },
    "SZ": {
        "name": "Swaziland"
    },
    "SE": {
        "name": "Suedia"
    },
    "CH": {
        "name": "Elveția"
    },
    "SY": {
        "name": "Siria"
    },
    "TJ": {
        "name": "Tadjikistan"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "TH": {
        "name": "Thailanda"
    },
    "TL": {
        "name": "Timorul de Est"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad și Tobago"
    },
    "TN": {
        "name": "Tunisia"
    },
    "TR": {
        "name": "Turcia"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UG": {
        "name": "Uganda"
    },
    "UA": {
        "name": "Ucraina"
    },
    "AE": {
        "name": "Emiratele Arabe Unite"
    },
    "GB": {
        "name": "Regatul Unit"
    },
    "US": {
        "name": "Statele Unite ale Americii"
    },
    "UY": {
        "name": "Uruguay"
    },
    "UZ": {
        "name": "Uzbekistan"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnam"
    },
    "YE": {
        "name": "Yemen"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    }
}